import PerformanceStore from './PerformanceStore.js'
import Workout from './Workout.js'

class WorkoutStore {
  static #KEY = "gimeWorkouts"

  static isActive() {
    return WorkoutStore.#load().some(workout => !workout.endedAt)
  }

  static start() {
    const all = WorkoutStore.#load()
    const workout = new Workout({ id: crypto.randomUUID(), startedAt: new Date().toISOString() })
    all.push(workout)
    WorkoutStore.#save(all)
    return workout
  }

  static end() {
    const all = WorkoutStore.#load()
    const current = all.find(workout => !workout.endedAt)
    if (!current) return
    current.endedAt = new Date().toISOString()
    WorkoutStore.#save(all)
  }

  static getCurrent() {
    const workout = WorkoutStore.#load().find(workout => !workout.endedAt)
    if (!workout) return null
    workout.performances = PerformanceStore.getForWorkout(workout)
    return workout
  }

  static #load() {
    try {
      return JSON.parse(localStorage.getItem(WorkoutStore.#KEY) ?? "[]").map(object => new Workout(object))
    } catch {
      return []
    }
  }

  static #save(workouts) {
    const data = workouts.map(workout => ({
      id: workout.id,
      startedAt: workout.startedAt,
      endedAt: workout.endedAt,
    }))
    localStorage.setItem(WorkoutStore.#KEY, JSON.stringify(data))
  }
}

export default WorkoutStore
